import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { EstoqueService } from 'src/app/services/EstoqueService/estoque.service';
import { IEstoqueItem } from 'src/app/services/EstoqueService/estoque.model';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';

type IOptions = { name: string; value: number };

@Component({
  selector: 'app-cadastro-saida-estoque',
  templateUrl: './cadastro-saida-estoque.component.html',
  styleUrls: ['./cadastro-saida-estoque.component.scss']
})
export class CadastroSaidaEstoqueComponent implements OnInit {
  form: FormGroup;
  isLoading = false;
  produtoOptions: IOptions[] = [];
  saldoPorProduto = new Map<number, number>();

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private estoqueService: EstoqueService,
    public swalAlert: SwalAlertService
  ) {
    this.form = this.fb.group({
      FK_PROD: [null, Validators.required],
      QT_MOVM: [null, [Validators.required, Validators.min(1)]],
      TX_OBSV: ['']
    });
  }

  ngOnInit(): void {
    this.loadProdutosComSaldo();
  }

  loadProdutosComSaldo(): void {
    this.isLoading = true;
    this.estoqueService
      .GetEstoquePaginated({
        FL_EM_ESTQ: true,
        PAGE_NUMBER: 1,
        PAGE_SIZE: 500
      })
      .subscribe({
        next: response => {
          const items = (response.ITEMS ?? []).filter(
            (item: IEstoqueItem) => Number(item.QT_SALD) > 0
          );
          this.saldoPorProduto.clear();
          items.forEach(item => {
            this.saldoPorProduto.set(item.PK_PROD, Number(item.QT_SALD));
          });
          this.produtoOptions = items.map(item => ({
            name: `${item.NM_PROD} (saldo: ${item.QT_SALD})`,
            value: item.PK_PROD
          }));
          this.isLoading = false;
        },
        error: () => {
          this.isLoading = false;
        }
      });
  }

  onSelectChange(event: number, name: string): void {
    this.form.controls[name].setValue(event);
  }

  postarDados(): void {
    if (!this.form.valid) {
      this.swalAlert.showAlert('Atenção!', 'Preencha produto e quantidade.', 'warning');
      return;
    }

    const fkProd = Number(this.form.controls['FK_PROD'].value);
    const quantidade = Number(this.form.controls['QT_MOVM'].value);
    const saldo = this.saldoPorProduto.get(fkProd);
    if (saldo !== undefined && quantidade > saldo) {
      this.swalAlert.showAlert(
        'Atenção!',
        `A quantidade informada excede o saldo disponível (${saldo}).`,
        'warning'
      );
      return;
    }

    const funcionarioId = Number(localStorage.getItem('id') ?? 0);
    this.isLoading = true;
    this.estoqueService
      .CreateSaida({
        FK_PROD: fkProd,
        QT_MOVM: quantidade,
        TX_OBSV: this.form.controls['TX_OBSV'].value || undefined,
        FK_FUNC_OPER: funcionarioId || undefined
      })
      .subscribe({
        next: () => {
          this.isLoading = false;
          this.router.navigate(['listagem/estoque']);
        },
        error: () => {
          this.isLoading = false;
        }
      });
  }
}
